<div class="cell_box">

  <cell-header
    cellHeaderHiding
    [cell]="cell"
    [class.-is-cell-body-hovered]="isCellBodyHovered">
  </cell-header>

  <div class="cell_body"
    customScrollbar
    [updateOn]="onResize$"
    (mouseenter)="isCellBodyHovered = true"
    (mouseleave)="isCellBodyHovered = false">
    <widget-body-renderer [widget]="cell.activeWidget"></widget-body-renderer>
  </div>

</div>

@if (isShadowed) {
  <div class="cell_shadow-overlay"></div>
}
